import { AlertCircle } from 'lucide-react';

export const ErrorAlert = ({ error, onRetry }) => {
    return (
        <div className="bg-red-50 border border-red-200 rounded-lg p-4">
            <div className="flex items-center gap-2">
                <AlertCircle className="w-5 h-5 text-red-500" />
                <p className="text-red-700">{error}</p>
            </div>
            {onRetry && (
                <button
                    onClick={onRetry}
                    className="mt-3 text-sm text-blue-600 hover:text-blue-700 font-medium"
                >
                    Try Again
                </button>
            )}
        </div>
    );
};
